import React from 'react'
import { motion } from 'framer-motion'
import { styled } from '@chilipiper/design-system'

export const BackgroundCircle = () => {
  const radius = 32
  const center = 37.5
  return (
    <>
      <StyledBaseCircle cx={center} cy={center} r={radius} fill='rgb(var(--primary-color))' />
      <MotionCircle
        cx={center}
        cy={center}
        r={radius}
        fill='rgba(255, 255, 255, 0.56)'
        animate={{ opacity: 0 }}
        transition={{ delay: 1.22, duration: 0.37 }}
      />
    </>
  )
}

const StyledBaseCircle = styled.circle`
  transform-origin: center;
  animation: pulse 0.97s ease-in-out 0.46s;
  @keyframes pulse {
    0%,
    100% {
      transform: scale(1);
    }
    // ~ 0.8s
    8.25% {
      transform: scale(1.17);
    }
    // ~ 0.89s
    91.75% {
      transform: scale(1.17);
    }
  }
`
const MotionCircle = motion(StyledBaseCircle)
